import { render } from "./TeacherMaster.vue?vue&type=template&id=35dac61e&scoped=true"
import script from "./TeacherMaster.vue?vue&type=script&lang=js"
export * from "./TeacherMaster.vue?vue&type=script&lang=js"

import "./TeacherMaster.vue?vue&type=style&index=0&id=35dac61e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dac61e"]])

export default __exports__